import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../ui/assets/logo.svg';
import LanguageSwitcher from './languageSwitcher';
import Modal from './modal';
import Wizard from './wizard';
import ExitProject from '../pages/exit-project/exitProject';

export default function Navbar({ step, showWizard, email, onClickSave }) {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  const handleClickCancel = () => {
    setShowModal(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo ">
        <Logo />
      </div>
      <div className="navbar__middle-content">{showWizard && <Wizard step={step} />}</div>
      <div className="navbar__end-content">
        <LanguageSwitcher />
        <Link to="/login" className="navbar__login-link" title="Login">
          <svg
            className="navbar__login-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
            <polyline points="10,17 15,12 10,7" />
            <line x1="15" y1="12" x2="3" y2="12" />
          </svg>
        </Link>
        <div onClick={() => setShowModal(true)}>{`${t('navbar.exitButton')} X`}</div>
        {showModal &&
          createPortal(
            <Modal onClose={() => setShowModal(false)}>
              <ExitProject
                originalEmail={email}
                onClickSave={onClickSave}
                onClickCancel={handleClickCancel}
              />
            </Modal>,
            document.body,
          )}
      </div>
    </nav>
  );
}
